module.exports = __webpack_public_path__ + "media/spot-error.80eeca90.svg";